export default class SelectedArea {
    areaCodes: number[];
    areaSetId: number | null;
    catchmentAreaId: number | null;

    constructor(areaCodes: number[], areaSetId: number | null = null, catchmentAreaId: number | null = null) {
        this.areaCodes = areaCodes;
        this.areaSetId = areaSetId;
        this.catchmentAreaId = catchmentAreaId;
    }
}